module.exports = __webpack_public_path__ + "img/web-dev-dave.955bf755.png";